import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { DeliveryOrderService } from './../../../../transport-operation/services/delivery-order.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { EventEmitter, Injector, Input, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TariffRateService } from '../../../service/tariff-rate.service';
import { getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';

@Component({
  selector: 'laas-tariff-rate-setting-import',
  templateUrl: './tariff-rate-setting-import.component.html',
  styleUrls: ['./tariff-rate-setting-import.component.scss']
})
export class TariffRateSettingImportComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() visibleChange: EventEmitter<any>;
  @Output() uploadClick: EventEmitter<any>;

  readonly preferenceKey: string;
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewTariffRateSetting;

  tariffRateRows: any[];
  forwarder: any;
  importForm: FormGroup;
  forwarderOptions: any[];
  isLoading: boolean;
  isVisible: boolean;
  columns: any[];

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private DOService: DeliveryOrderService,
    private dropdownOptionsService: DropdownOptionsService,
    private tariffRateService: TariffRateService,
    private formBuilder: FormBuilder
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.TariffRateSettingImport;
    this.tariffRateRows = [];
    this.forwarder = null;
    this.forwarderOptions = [];
    this.isLoading = false;
    this.isVisible = false;
    this.visibleChange = new EventEmitter<any>();
    this.uploadClick = new EventEmitter<any>();

    this.columns = [
      { field: 'forwarder', header: 'TariffRateImport.Forwarder', sort: true },
      { field: 'sku', header: 'TariffRateImport.SKU', sort: true },
      { field: 'tariffRate', header: 'TariffRateImport.TariffRate', sort: true },
      { field: 'customsTariff', header: 'TariffRateImport.CustomsNum', sort: true },
      { field: 'skuDescription', header: 'TariffRateImport.PartNumDescription', sort: true },
      { field: 'declarationDt', header: 'TariffRateImport.FilingDate', dataType: 'date', sort: true },
      { field: 'brand', header: 'TariffRateImport.Brand', sort: true },
      { field: 'startDt', header: 'TariffRateImport.EffectiveStartDate', dataType: 'date', sort: true },
      { field: 'endDt', header: 'TariffRateImport.EffectiveEndDate', dataType: 'date', sort: true },
    ];

    this.importForm = this.formBuilder.group({
      forwarder: null
    });
  }

  @Input() get visible(): any {
    return this.isVisible;
  }
  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return (this.userProfile.userType === UserType.SuperAdmin.toString() ||
            this.userProfile.userType === UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));

        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.forwarderOptions.unshift({
                label: msg,
                value: null
              });

            }
          });

      }
    });
  }

  fileUploader(event: any): void {
    this.isLoading = true;
    this.tariffRateService.importTariffRateByExcel(event.files[0], this.laasSetting.facility, this.userProfile.userName).subscribe({
      next: result => {
        this.tariffRateRows = result;
      },
      complete: () => {
        this.clearUploadUI();
        this.isLoading = false;
      }
    });
  }

  clearUploadUI(): void {
    this.fileUpload.clear();
  }

  importClickBtn(event: any): void {
    if (this.tariffRateRows.filter(x => !isNullOrEmpty(x.forwarder)).some(x => this.forwarderOptions.every(y => x.forwarder !== y.value))) {
      this.toastService.warn(this.translateService.instant('TariffRate.Alert.ForwarderCorrect'));
      return;
    }

    if (this.tariffRateRows.some(x => x.sku === null)) {
      this.toastService.warn(this.translateService.instant('TariffRate.Alert.SKUBlank'));
      return;
    }

    if (this.tariffRateRows.some(x => x.tariffRate === null)) {
      this.toastService.warn(this.translateService.instant('TariffRate.Alert.TariffBlank'));
      return;
    }

    this.tariffRateRows.forEach(x => {
      x.forwarder = this.forwarder != null ? this.forwarder : x.forwarder;
      x.declarationDt = isNullOrEmpty(x.declarationDt) ? null : new Date(x.declarationDt).toISOString();
      x.startDt = isNullOrEmpty(x.startDt) ? null : new Date(x.startDt).toISOString();
      x.endDt = isNullOrEmpty(x.endDt) ? null : new Date(x.endDt).toISOString();
      x.isActivated = '1';
      this.tariffRateService.addTariffRate(x).subscribe({
        next: result => {
          this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
              }
            });
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
    });
    this.tariffRateRows = [];
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  templateDownloadClickBtn(event: any): void {
    this.commonDataService.getSystemParam('TariffRateSetting').subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.DOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = `TariffRate_Sample.xlsx`;
          link.click();
        });
      }
    });
  }
}
